const scrollTo = () => {
  const scrollToButton = document.querySelectorAll('[data-scrollto]');

  Object.values(scrollToButton).map(button =>
    button.addEventListener('click', () => {
      const element = document.getElementById(button.dataset.scrollto);

      element.scrollIntoView({behavior: 'smooth', block: button.dataset.scrolltoAlign ?? 'center'});
    }),
  );
};

export default scrollTo;
